<template>
    <div class="management">
        <h5>Your ip is {{ip}}</h5>
        <h1>Management</h1>
        <div>
            <b-tabs content-class="mt-3">
                <!-- <b-tab title="Staff" active>
                    <b-button v-b-modal.modal-create-staff variant="primary">Add a new staff</b-button>
                    <b-table class="mt-3" striped :fields="staff_fields" hover :items="staffs"></b-table>
                </b-tab>
                <b-tab title="Cemetery">
                    <b-button v-b-modal.modal-create-cemetery variant="primary">Add a new cemetery</b-button>
                    <b-table class="mt-3" striped :fields="cemetery_fields" hover :items="cemeteries"></b-table>
                </b-tab> -->
                <b-tab title="IP List">
                    <b-button v-b-modal.modal-create-ip variant="primary">Register a new ip</b-button>
                    <b-table class="mt-3" striped :fields="ip_fields" hover :items="iPs"></b-table>
                </b-tab>
            </b-tabs>
        </div>

        <b-modal id="modal-create-staff" hide-footer title="Add a new staff">
            <label for="staff_email">Email:</label>
            <input type="text" 
              id="staff_email" 
              v-model="staff.staff_email" 
              class="form-control">
            <label for="staff_password">Password:</label>
            <input type="text" 
              id="staff_password" 
              v-model="staff.staff_password" 
              class="form-control">
            <label for="staff_name">Name:</label>
            <input type="text" 
              id="staff_name" 
              v-model="staff.staff_name" 
              class="form-control">
            <label for="staff_role">Role:</label>
            <b-form-select 
              v-model="staff.staff_role" 
              :options="staff_roles"></b-form-select>
            <div class="modal-footer">
                <b-button @click="hideModal()"> Cancel </b-button>
                <b-button @click="createStaff()" variant="primary">Create</b-button>
            </div>
        </b-modal>

        <b-modal id="modal-create-cemetery" title="Add a new cemetery">
            <label for="cemetery_name">Name:</label>
            <input type="text" 
              id="cemetery_name" 
              v-model="cemetery_name" 
              class="form-control">
        </b-modal>

        <b-modal id="modal-create-ip" hide-footer title="Register a new ip">
            <label for="ip_name">Name:</label>
            <input type="text" 
              id="ip_name" 
              v-model="ip_name" 
              class="form-control">

            <label for="ip_ip">IP:</label>
            <input type="text" 
              id="ip_ip" 
              v-model="ip_ip" 
              class="form-control">
            <div class="modal-footer">
                <b-button @click="hideModal()"> Cancel </b-button>
                <b-button @click="registerIP()" variant="primary">Create</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import firebase from 'firebase';

export default {
    name: "Management",
    data() {
        return {
            ip: "",
            staff: {
                staff_email: '',
                staff_password: '',
                staff_name: '',
                staff_role: ''
            },
            cemetery_name: '',
            staffs: [],
            cemeteries: [],
            staff_fields: [
                { key: 'name', label: 'Name', sortDirection: 'asc' },
                { key: 'email', label: 'Email'},
                { key: 'role', label: 'Role'}
            ],
            cemetery_fields: [
                { key: 'name', label: 'Name', sortDirection: 'asc' }
            ],
            ip_fields: [
                { key: 'name', label: 'Name', sortDirection: 'asc' },
                { key: 'ip', label: 'IP'}
            ],
            staff_roles: [
                'sales',
                'worker'
            ],
            ip_name: '',
            ip_ip: '',
            iPs: []
        }
    },
    mounted() {
        fetch("https://api.ipify.org?format=json")
            .then((x) => x.json())
            .then(({ip}) => {
                this.ip = ip;
            });

        firebase.firestore().collection('staffs').onSnapshot((collection) => {
          this.staffs = collection.docs.map(doc => doc.data());
        });

        firebase.firestore().collection('cemeteries').onSnapshot((collection) => {
          this.cemeteries = collection.docs.map(doc => doc.data());
        });

        firebase.firestore().collection('ip').onSnapshot((collection) => {
          this.iPs = collection.docs.map(doc => doc.data());
        });
    },
    methods: {
        registerIP() {
            var cemeteryRef = firebase.firestore().collection("ip").doc();
            cemeteryRef.set({
                name: this.ip_name,
                ip: this.ip_ip
            });
            this.$bvModal.hide('modal-create-ip');
            alert("Create successfully");
        },
        hideModal() {
            this.$bvModal.hide('modal-create-staff');
            this.$bvModal.hide('modal-create-cemetery');
            this.$bvModal.hide('modal-create-ip');
        },
        createStaff() {
            var self = this;
            firebase.auth().createUserWithEmailAndPassword(this.staff.staff_email, this.staff.staff_password)
                .then(user => {
                    var id = user.user.uid;
                    console.log(id);
                    console.log(user);

                    var staffRef = firebase.firestore().collection("staffs").doc(id);
                    staffRef.set({
                        id: id,
                        email: this.staff.staff_email,
                        name: this.staff.staff_name,
                        role: this.staff.staff_role
                    });

                    var userRef = firebase.firestore().collection("users").doc(id);
                    userRef.set({
                        id: id,
                        email: this.staff.staff_email,
                        name: this.staff.staff_name,
                        role: this.staff.staff_role
                    });

                    var roleRef = firebase.firestore().collection(this.staff.staff_role + 's').doc(id);
                    roleRef.set({
                        id: id,
                        email: this.staff.staff_email,
                        name: this.staff.staff_name,
                        role: this.staff.staff_role
                    });

                    self.$bvModal.hide('modal-create-staff');
                    alert(id + "Create successfully");
                })
                .catch(error => {
                    alert(error.message);
                });
        },
        createCemetery() {
            var cemeteryRef = firebase.firestore().collection("cemetery").doc();
            cemeteryRef.set({
                id: cemeteryRef.id,
                name: this.cemetery_name
            });
            this.$bvModal.hide('modal-create-cemetery');
            alert("Create successfully");
        }
    }
}
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>